<template>
    <Component
        :is="contentfulContentBlock"
        v-if="errorContent"
        :contentRows="errorContent.rows"
        :contentTitle="errorContent.title"
        class="o-container"
    />
</template>

<script setup>
import { onBeforeMount } from 'vue';
import { useActions, useState } from '~coreModules/core/js/composables/vuexHelpers';
import useAnalyticsPageView from '~coreModules/analytics/js/composables/use-analytics-pageview';

import { useLogger } from '~coreModules/core/js/composables/useLogger';
import { CONTENT_SLUGS } from '~coreModules/contentful/js/contentful-constants';
import { FETCH_ERROR_CONTENT } from '~coreModules/core/js/store';

defineProps({
    contentfulContentBlock: {
        type: [Function, Object],
        required: true,
    },
});

const logger = useLogger();
useAnalyticsPageView();

const { routingError, errorContent } = useState(['routingError', 'errorContent']);

const { fetchErrorContent } = useActions({
    fetchErrorContent: FETCH_ERROR_CONTENT,
});

onBeforeMount(async () => {
    logger.debugError('Rendering 500 view due to error: ', routingError);
    await fetchErrorContent({ slug: CONTENT_SLUGS.ERROR_500_PAGE });
});

</script>
